export class FlightSelectDto {
  requestId: string;
  flights: number[];
  userUuid?: string;
}
